import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import { articles, featuredArticles, categories } from '@/mocks/articles';

const heroBgImage = 'https://readdy.ai/api/search-image?query=Abstract%20dark%20cinematic%20atmosphere%20with%20dramatic%20lighting%20deep%20black%20background%20with%20subtle%20crimson%20and%20golden%20particles%20floating%20mysterious%20glowing%20threads%20of%20light%20weaving%20through%20shadows%20elegant%20minimalist%20texture%20no%20text%20no%20people%20striking%20contrast%20between%20darkness%20and%20warm%20accent%20lighting%20editorial%20quality%20fine%20art%20photography&width=1600&height=900&seq=homepage-hero-bg&orientation=landscape';

const heroFans = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20backstage%20photography%20of%20a%20single%20spotlight%20on%20an%20empty%20stage%20with%20a%20fallen%20microphone%20dramatic%20shadows%20deep%20crimson%20and%20black%20tones%20cinematic%20noir%20atmosphere%20mysterious%20elegant%20composition&width=600&height=800&seq=hero-fan-01&orientation=portrait',
    category: '重磅爆料',
    title: '顶流塌房',
    accent: 'bg-primary-500',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20photography%20of%20a%20partially%20open%20door%20with%20bright%20light%20spilling%20through%20the%20crack%20casting%20long%20dramatic%20shadows%20on%20floor%20mysterious%20and%20suspenseful%20deep%20charcoal%20and%20golden%20accents%20cinematic%20composition&width=600&height=800&seq=hero-fan-02&orientation=portrait',
    category: '独家视频',
    title: '录音曝光',
    accent: 'bg-accent-500',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20closeup%20of%20a%20shattered%20phone%20screen%20with%20glowing%20cracks%20reflecting%20red%20light%20lying%20on%20a%20dark%20surface%20mysterious%20atmosphere%20cinematic%20lighting%20deep%20blacks%20with%20neon%20red%20reflections%20editorial%20photography&width=600&height=800&seq=hero-fan-03&orientation=portrait',
    category: '深度追踪',
    title: '直播翻车',
    accent: 'bg-secondary-500',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20photography%20of%20scattered%20papers%20and%20photographs%20on%20a%20dark%20wooden%20table%20with%20a%20red%20string%20connecting%20them%20like%20an%20investigation%20board%20dramatic%20top%20lighting%20noir%20atmosphere%20deep%20shadows%20moody&width=600&height=800&seq=hero-fan-04&orientation=portrait',
    category: '实锤证据',
    title: '图文揭秘',
    accent: 'bg-primary-500',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20elegant%20photography%20of%20a%20single%20red%20envelope%20with%20wax%20seal%20on%20black%20velvet%20surface%20dramatic%20spotlight%20creating%20sharp%20shadows%20mysterious%20and%20sophisticated%20atmosphere%20cinematic%20noir%20style%20with%20rich%20blacks%20and%20crimson%20highlights&width=600&height=800&seq=hero-fan-05&orientation=portrait',
    category: '圈内爆料',
    title: '内幕揭秘',
    accent: 'bg-accent-500',
  },
];

const featureGridImageLarge = 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20photography%20of%20a7%20luxurious%20dressing%20room%20with%20vanity%20mirror%20reflecting%20multiple%20faces%20in%20distorted%20angles%20warm%20makeup%20lights%20creating%20dramatic%20contrast%20with%20surrounding%20darkness%20mysterious%20atmosphere%20deep%20shadows%20editorial%20fashion%20noir&width=800&height=1200&seq=feature-large&orientation=portrait';

const featureGridImageTop = 'https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20of%20a%20recording%20studio%20control%20room%20with%20glowing%20audio%20waveforms%20on%20multiple%20monitors%20headphones%20hanging%20in%20foreground%20dramatic%20blue%20screen%20glow%20contrasting%20with%20dark%20surroundings%20cinematic%20tech%20noir%20atmosphere&width=800&height=500&seq=feature-top&orientation=landscape';

const featureGridImageBottom = 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20photography%20of%20a%20single%20spotlight%20illuminating%20a%20stack%20of%20printed%20documents%20with%20official%20stamps%20on%20a%20dark%20desk%20surrounded%20by%20deep%20shadows%20cinematic%20noir%20atmosphere%20suspenseful%20investigative%20mood&width=800&height=500&seq=feature-bottom&orientation=landscape';

const ctaBgImage = 'https://readdy.ai/api/search-image?query=Abstract%20dark%20background%20with%20flowing%20ribbons%20of%20golden%20and%20crimson%20light%20particles%20drifting%20across%20deep%20black%20space%20elegant%20minimalist%20texture%20no%20text%20smooth%20gradient%20from%20darkness%20to%20subtle%20warm%20glow%20fine%20art%20aesthetic&width=1600&height=400&seq=cta-bg&orientation=landscape';

export default function Home() {
  return (
    <>
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background-50">
          <div className="absolute inset-0">
            <img src={heroBgImage} alt="" className="w-full h-full object-cover opacity-40" loading="eager" />
            <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/60 to-background-50"></div>
          </div>

          <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10 pt-24 md:pt-32 pb-16 md:pb-20 text-center">
            <div className="mb-8 md:mb-12">
              <p className="text-accent-500 font-label text-sm tracking-widest uppercase mb-4">吃瓜永不停歇</p>
              <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-foreground-950 leading-tight mb-3">
                吃瓜不<strong className="text-primary-500 font-heading">打烊</strong>
              </h1>
              <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl text-foreground-800 leading-tight">
                51黑料<span className="text-accent-500">·</span>深度追踪
              </h2>
            </div>

            {/* 3D Fan Cards */}
            <div className="flex items-center justify-center gap-2 md:gap-4 mb-8 md:mb-12 perspective-[1200px]">
              {heroFans.map((fan, i) => {
                const offset = i - 2;
                const rotateY = offset * 8;
                const translateY = Math.abs(offset) * 10;
                const zIndex = 5 - Math.abs(offset);
                const scale = 1 - Math.abs(offset) * 0.04;
                return (
                  <a
                    key={i}
                    href={`/category/${categories[i]?.slug || 'mingxing-bagua'}`}
                    className="relative w-[100px] md:w-[160px] lg:w-[200px] shrink-0 transition-all duration-500 hover:scale-105 hover:z-20 group cursor-pointer"
                    style={{
                      transform: `rotateY(${rotateY}deg) translateY(${translateY}px) scale(${scale})`,
                      zIndex,
                    }}
                  >
                    <div className="relative aspect-[3/4] rounded-2xl md:rounded-3xl overflow-hidden">
                      <img src={fan.image} alt={fan.title} className="w-full h-full object-cover" loading="lazy" />
                      <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent"></div>
                      <div className={`absolute top-2 left-2 md:top-3 md:left-3 ${fan.accent} text-background-50 text-[10px] md:text-xs px-2 md:px-3 py-1 rounded-full font-label`}>
                        {fan.category}
                      </div>
                      <div className="absolute bottom-3 md:bottom-5 left-0 right-0 text-center">
                        <p className="text-foreground-950 font-heading text-sm md:text-lg">{fan.title}</p>
                      </div>
                    </div>
                  </a>
                );
              })}
            </div>

            <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
              聚合全网<strong className="text-accent-500 font-semibold">热门爆料</strong>与<strong className="text-primary-500 font-semibold">深度八卦</strong>，覆盖51黑料在线观看、吃瓜视频等热门内容。无论你想找最新入口还是回味经典塌房现场，都能一站聚合，让吃瓜不再断档。
            </p>

            <div className="flex items-center justify-center gap-4 flex-wrap">
              <a href="/category/mingxing-bagua" className="btn-accent text-sm md:text-base px-8 py-3.5 flex items-center gap-2">
                开始吃瓜 <i className="ri-arrow-right-line"></i>
              </a>
              <a href="/about" className="text-foreground-500 hover:text-foreground-950 text-sm md:text-base transition-colors duration-200">
                了解更多 →
              </a>
            </div>
          </div>
        </section>

        {/* Feature Grid Section */}
        <section className="py-14 md:py-24 px-4 md:px-6 lg:px-10">
          <div className="max-w-[1400px] mx-auto">
            <div className="text-center mb-10 md:mb-16">
              <span className="text-accent-500 text-sm font-label tracking-widest">热门专题</span>
              <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 mt-2 mb-2">
                热门<strong className="text-primary-500 font-heading">黑料</strong>
              </h2>
              <p className="text-foreground-500 text-sm md:text-base">深度吃瓜 · 不容错过</p>
            </div>

            <div className="flex flex-col lg:flex-row gap-4 md:gap-5">
              {/* Large Featured Card */}
              {featuredArticles[0] && (
                <div className="lg:w-1/2">
                  <a href={`/article/${featuredArticles[0].id}`} className="card-dark group h-full block">
                    <div className="relative h-full min-h-[400px] md:min-h-[500px] overflow-hidden">
                      <img src={featuredArticles[0].image} alt={featuredArticles[0].title} className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                      <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/30 to-transparent"></div>
                      <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                        <span className="bg-primary-500/30 text-primary-300 tag-pill mb-3">
                          <i className="ri-fire-line mr-1"></i>重磅爆料
                        </span>
                        <h3 className="text-foreground-950 font-heading text-xl md:text-3xl leading-snug mb-3 line-clamp-2">
                          {featuredArticles[0].title}
                        </h3>
                        <p className="text-foreground-400 text-sm md:text-base line-clamp-2">{featuredArticles[0].excerpt}</p>
                        <div className="flex items-center gap-4 mt-4 text-foreground-400 text-xs md:text-sm">
                          <span className="flex items-center gap-1"><i className="ri-eye-line"></i>128.5万</span>
                          <span className="flex items-center gap-1"><i className="ri-chat-3-line"></i>3.8万</span>
                          <span>{featuredArticles[0].date}</span>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              )}

              {/* Right Side Stack */}
              <div className="lg:w-1/2 flex flex-col gap-4 md:gap-5">
                {featuredArticles[1] && (
                  <a href={`/article/${featuredArticles[1].id}`} className="card-dark group flex-1">
                    <div className="relative h-full min-h-[200px] md:min-h-[240px] overflow-hidden">
                      <img src={featuredArticles[1].image} alt={featuredArticles[1].title} className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                      <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/40 to-transparent"></div>
                      <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                        <span className="bg-accent-500/30 text-accent-300 tag-pill mb-2">
                          <i className="ri-video-line mr-1"></i>视频黑料
                        </span>
                        <h3 className="text-foreground-950 font-heading text-lg md:text-xl leading-snug line-clamp-2">
                          {featuredArticles[1].title}
                        </h3>
                      </div>
                    </div>
                  </a>
                )}
                {featuredArticles[2] && (
                  <a href={`/article/${featuredArticles[2].id}`} className="card-dark group flex-1">
                    <div className="relative h-full min-h-[200px] md:min-h-[240px] overflow-hidden">
                      <img src={featuredArticles[2].image} alt={featuredArticles[2].title} className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                      <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/40 to-transparent"></div>
                      <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                        <span className="bg-secondary-500/30 text-secondary-300 tag-pill mb-2">
                          <i className="ri-image-line mr-1"></i>图文实锤
                        </span>
                        <h3 className="text-foreground-950 font-heading text-lg md:text-xl leading-snug line-clamp-2">
                          {featuredArticles[2].title}
                        </h3>
                      </div>
                    </div>
                  </a>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* 4-Column Hot Stream */}
        <section className="py-14 md:py-24 px-4 md:px-6 lg:px-10 bg-background-100/50">
          <div className="max-w-[1400px] mx-auto">
            <div className="mb-10 md:mb-16">
              <span className="text-accent-500 text-sm font-label tracking-widest">最新爆料</span>
              <div className="flex items-end justify-between mt-2">
                <div>
                  <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950">
                    最新<strong className="text-primary-500 font-heading">爆料</strong>
                  </h2>
                  <p className="font-heading text-xl md:text-2xl text-foreground-500 italic">吃瓜不打烊</p>
                </div>
                <a href="/category/mingxing-bagua" className="hidden sm:flex items-center gap-1 text-foreground-500 hover:text-primary-500 text-sm transition-colors duration-200 whitespace-nowrap">
                  查看全部 <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
              {articles.slice(0, 8).map((article) => (
                <ArticleCard
                  key={article.id}
                  id={article.id}
                  title={article.title}
                  excerpt={article.excerpt}
                  category={article.category}
                  categorySlug={article.categorySlug}
                  image={article.image}
                  date={article.date}
                  views={article.views}
                  comments={article.comments}
                  tags={article.tags}
                />
              ))}
            </div>

            <div className="mt-8 text-center sm:hidden">
              <a href="/category/mingxing-bagua" className="btn-outline text-sm inline-flex items-center gap-2">
                查看全部爆料 <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </section>

        {/* Category Quick Links */}
        <section className="py-14 md:py-20 px-4 md:px-6 lg:px-10">
          <div className="max-w-[1400px] mx-auto">
            <div className="mb-10 md:mb-14 text-center">
              <span className="text-accent-500 text-sm font-label tracking-widest">分类导航</span>
              <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-950 mt-2">
                探索<strong className="text-secondary-500 font-heading">分类</strong>
              </h2>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
              {categories.map((cat, i) => {
                const colors = [
                  'from-primary-500/20 to-primary-500/5 border-primary-500/20 hover:border-primary-500/40',
                  'from-accent-500/20 to-accent-500/5 border-accent-500/20 hover:border-accent-500/40',
                  'from-secondary-500/20 to-secondary-500/5 border-secondary-500/20 hover:border-secondary-500/40',
                  'from-primary-500/15 to-primary-500/5 border-primary-500/20 hover:border-primary-500/40',
                  'from-accent-500/15 to-accent-500/5 border-accent-500/20 hover:border-accent-500/40',
                  'from-secondary-500/15 to-secondary-500/5 border-secondary-500/20 hover:border-secondary-500/40',
                  'from-primary-500/20 to-primary-500/5 border-primary-500/20 hover:border-primary-500/40',
                  'from-accent-500/20 to-accent-500/5 border-accent-500/20 hover:border-accent-500/40',
                ];
                const iconColors = [
                  'text-primary-400', 'text-accent-400', 'text-secondary-400',
                  'text-primary-400', 'text-accent-400', 'text-secondary-400',
                  'text-primary-400', 'text-accent-400',
                ];
                return (
                  <a
                    key={cat.slug}
                    href={`/category/${cat.slug}`}
                    className={`bg-gradient-to-br ${colors[i]} border rounded-2xl p-4 md:p-6 transition-all duration-300 hover:scale-[1.02] cursor-pointer group`}
                  >
                    <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl bg-background-100 flex items-center justify-center mb-3 md:mb-4 ${iconColors[i]} group-hover:scale-110 transition-transform duration-300`}>
                      <i className={`${cat.icon} text-lg md:text-xl`}></i>
                    </div>
                    <h3 className="text-foreground-950 font-heading text-sm md:text-base">{cat.name}</h3>
                    <p className="text-foreground-400 text-xs mt-1">查看全部 →</p>
                  </a>
                );
              })}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-16 md:py-24 overflow-hidden">
          <div className="absolute inset-0">
            <img src={ctaBgImage} alt="" className="w-full h-full object-cover opacity-20" loading="lazy" />
          </div>
          <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10 text-center">
            <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 mb-4">
              有料你就<strong className="text-primary-500 font-heading">爆</strong>
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto mb-8">
              如果你有独家爆料，欢迎投稿。我们保护每一位爆料人的隐私安全，让真相浮出水面。
            </p>
            <a href="/about" className="btn-accent inline-flex items-center gap-2 text-sm md:text-base px-8 py-3.5">
              <i className="ri-send-plane-line"></i> 立即爆料
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}